<template>
    <div class="inner-content  w-4/6 lg:w-1/2" id="inner-content">
        <div class="breadcrumb-wrap mdr:hidden">
            <ul class="breadcrumb flex flex-wrap justify-start text-1.6rem px-16">
                <template v-for="(single, index) in breadcrumb" :key="index">
                <li v-if="$last">{{ single.page }}</li>
                 <li v-else>   
                    <a :href="single.url">{{ single.page }}</a>
                </li>
                </template>
            </ul>
        </div>
        <div :class="parentSel" ref="scrollText">
            <parallax-text v-for="(paragraph, index) in dataParseText" :key="index" :container="container"
                :is-page="dataConfig.isPage" :scroll-top="scrollTop">
               <div v-html="paragraph.outerHTML !== '' ? paragraph.outerHTML : ''" class="elem"></div> 
             
            </parallax-text>


        </div>

    </div>
    <div
        class="navbar-scroll lg:w-1/12 w-2/12 fixed right-0 top-0 z-20 h-full flex flex-wrap flex-col justify-center items-center">
        <div class="buttons-scroll">
            <ul>
                <li v-for=" (item, i) in dataMenu" :key="i">
                    <scroll-anchor :anchor="`#${cleanText(item)}`"
                        @scrollon-anchor="setScrollTop"><span>{{ item }}</span></scroll-anchor>
                </li>
                <li v-if="dataConfig.isArtist">
                    <a :href="`${getDomain}/?artistmanager_artist_id=${post}`" target="_blank">PDF</a>
                </li>

            </ul>
        </div>
    </div>
</template>

<script>
import { getElementsByTagNames } from '../scripts/utils'
import { canvasBackground } from '../scripts/canvasBackground'
import { getContentPost } from '../scripts/getAxios'
export default {
    name: 'scroll-text',
    props: {
        dataText: {
            type: String,
            default: ''
        },
        breadcrumb: {
            type: String,
            default: ''
        },
        gallery: {
            type: String,
            default: ''
        },
        profilo: {
            type: String,
            default: ''
        },
        post: {
            type: Number,
            default: 0
        },
        config: {
            type: Object,
            default: () => { }
        },
        parentSel: {
            type: String,
            default: 'content-text'
        },
        dataMenu: {
            type: Array,
            default: []
        },
        press:{
            type: String,
            default:''
        }


    },
    data() {
        return {
            dataConfig: {
                isPage: true,
                isArtist: true,
                postType: 'production'
            },
            $last: null,
            endpoint: '',
            isOpened: false,
            contentPicture: () => { },
            contentText: '',
            container: () => { },
            scroll: true,
            dataParseText: [],
            el: null,
            rect: null,
            scrollTop: 0,
            scrollingPage: 0,
            containerPos: () => { }
        }
    },
    methods: {
        setScrollTop(n) {
            //document.documentElement.scrollTop = document.body.scrollTop = n;
            console.log(n)
            document.documentElement.scrollTo({ top: n, behavior: 'smooth' })
        },
        initScrollText() {
            canvasBackground()
        },
        postInit() {
            const postId = this.post
            if (postId == 0) return false

            const res = getContentPost(this.endpoint + postId).then(res => {
                console.log(res)
                this.contentText = res.data.content.rendered
                this.parseText()
            })


        },
        parseText() {
            let parser = new DOMParser();
            const contentMerge = this.profilo + this.contentText 
            const doc = parser.parseFromString(contentMerge, 'text/html');
            let parag = getElementsByTagNames('p,img,iframe,figure,h1,h4,h2,a', doc);
            if (this.press){
                parag.push({outerHTML:'<h4 id="press">PRESS</h4>'})
                parag.push({outerHTML:this.press})
                
            }
            if (this.gallery){
                const docgal = parser.parseFromString(this.gallery, 'text/html');
                const gal = getElementsByTagNames('img,figure,h4', docgal);
                parag = parag.concat(gal);
                
            }
            console.log('paragraph', parag )
            this.dataParseText = parag

        },
        handleScroll(e) {
            this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const rawObjectData = { ...this.$data }
            const { el, contentPicture, container, isOpened, containerPos } = rawObjectData
            if (this.scrollTop > 30 && !isOpened) {
                const body = document.querySelector('body');

                body.style.height = `${this.getContainer.height + 500}px`
                contentPicture.style.transform = 'translate(-75%, 0px) rotateY(50deg)';
                contentPicture.style.opacity = '0.25';
                contentPicture.style.zIndex = '-2';
                container.offsetParent.style.zIndex = '20'
                this.isOpened = true;
            } else if (this.scrollTop <= 5 && isOpened) {
                contentPicture.style.transform = 'translate(0%, 0) rotateY(0)';
                contentPicture.style.opacity = '1';
                contentPicture.style.zIndex = '10';
                this.isOpened = false
                container.offsetParent.style.zIndex = 'auto'
            }
            container.style.transform = `translateY(-${this.scrollTop}px)`
        },
        cleanText(textString){
            const regex = /[\s,]+/g; // [\s,]+ corrisponde a uno o più spazi o virgole
            return textString.replace(regex, "-");
        }
    },
    computed: {
        getContainer() {
            return this.el.offsetParent.getBoundingClientRect();
        },
        getDomain() {
            return process.env.WORDPRESS_BASE_URL
        },
        getTotalParagraph(){
            console.log(this.dataParseText.lenght)
            return 40
        }
    },
    mounted() {
        this.dataConfig = { ...this.dataConfig, ...this.config }
        const domain = window.location.host
        this.endpoint = `${process.env.WORDPRESS_BASE_URL}/wp-json/wp/v2/${this.dataConfig.postType}/`
        const body = document.querySelector('body');
        this.contentPicture = document.querySelector('.single-actor__wrap__left .inner-content')

        
        this.dataConfig.isPage ? this.initScrollText() : null
        if (this.dataText !== '' || this.profilo !== '') {
            this.contentText = this.dataText
            this.parseText();
        } else {
            this.postInit()
        }



        this.el = this.$refs.scrollText
        this.container = this.el.offsetParent
        this.containerPos = this.el.offsetParent.getBoundingClientRect();
        this.rect = this.el.getBoundingClientRect();
        if (this.dataConfig.isPage) {
            window.addEventListener('scroll', this.handleScroll)

        }


    },
}
</script>

<style lang="scss" scoped>
.breadcrumb-wrap {
    top: 25rem;
    position: relative;
    left: -5rem;
}

.navbar-scroll{
    @screen mdr{
        right:5rem;
    }
}

.section-container {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    -webkit-perspective: 1000;
    margin-top: 500px;
}

.content-text {
    position: absolute;
    overflow-y: scroll;
    height: 100%;
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    box-sizing: border-box;
    padding: 2rem 1rem;
    @screen mdr{
        height: calc(100% - 450px);
    }

    @screen lg {
        padding: 2rem 5rem;
    }


    /* Hide scrollbar for Chrome, Safari and Opera */
    &::-webkit-scrollbar {
        display: none;
    }

}
</style>